import { render, staticRenderFns } from "./BusinessAnnualReturnsDetails.vue?vue&type=template&id=4fa17b22&scoped=true&"
import script from "./BusinessAnnualReturnsDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnsDetails.vue?vue&type=style&index=0&id=4fa17b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa17b22",
  null
  
)

export default component.exports